import {
  useGetWorkspaceProfileQuery,
  WorkspaceProfileFragment,
} from '@sketch/gql-types'

export interface WorkspaceProfileResultSuccess {
  loading: false
  profile: WorkspaceProfileFragment
  error?: undefined
}

export interface WorkspaceProfileResultLoading {
  loading: true
  profile: WorkspaceProfileFragment | undefined
  error?: undefined
}

export interface WorkspaceProfileResultError {
  loading?: false
  profile?: undefined
  // At the moment only 'NOT_FOUND' error is expected
  error: { type: 'NOT_FOUND' }
}

export type WorkspaceProfileResult =
  | WorkspaceProfileResultSuccess
  | WorkspaceProfileResultLoading
  | WorkspaceProfileResultError

export const useGetWorkspaceProfile = (
  workspaceId: string
): WorkspaceProfileResult => {
  const { data, loading, error } = useGetWorkspaceProfileQuery({
    variables: { workspaceIdentifier: workspaceId },
  })

  const profile = data?.workspaceProfile

  if (loading) {
    return { loading, profile }
  }

  if (error || !profile) {
    return { error: { type: 'NOT_FOUND' } }
  }

  return { loading, profile }
}
